<section [class]="bgClass">
  <header class="h2 mb-4 vm-section__header"
          [ngClass]="{
      'vm-section-expand-collapse': isexpandable,
      collapsed: !isexpanded
    }"
          data-toggle="collapse"
          data-target="#pagecollapseThree"
          aria-expanded="true"
          aria-controls="pagecollapseThree"
          [style]="headerStyle"
          [class]="headerCss">
    <span (click)="expand()">
      {{ name }}
    </span>
    <small *ngIf="hinttext != '' && isbeside" class="vm-hint-inline text-muted">
      {{ hinttext }}
    </small>
    <div (click)="expand()" [ngClass]="{ 'vm-arrow': isexpandable }">
      <ng-container *ngIf="isexpandable">
        <span class="material-symbols-outlined vm-icons">
          expand_more
        </span>
      </ng-container>
    </div>
    <div>
      <ng-content select="[header]"></ng-content>
    </div>
  </header>

  <small *ngIf="hinttext != '' && !isbeside"
         style="margin-top: -2rem"
         class="vm-hint text-muted">
    {{ hinttext }}
  </small>
  <div class="vm-content collapse show" *ngIf="isexpanded">
    <ng-content select="[body]"></ng-content>
  </div>
  <span class="vm-border-bottom"></span>
</section>
